module.exports = __webpack_public_path__ + "img/4.cc9d42fd.jpg";